import { Injectable } from '@angular/core';
import { BearerHttpService } from '../../services/bearer-http.service';
import { ModelService } from 'src/app/services/model.service';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/app.config';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ProjectDetailService {
	constructor(
		private http: BearerHttpService,
	) { }

	// Actualizar el estado.
	public updateProject(projectData: ProjectData): Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/configProyecto/' + projectData._id + '/estado/' + projectData.estado,
			{ estado: projectData.estado })
			.pipe(map(res => {
				if (typeof res === 'string') {
					projectData._id = res;
				}
				return projectData._id;
			}));
	}

	public sendProject(datas: any): Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/sendProject/', { datas }).pipe(map(res => { return res; }));
	}

}
